<div class="kx-cstm-popup-overlay" (click)="onOverlayClicked($event)">
  <div class="kx-cstm-popup-dialog" [class.modal-sm]="size == ModalSize.Sm" [class.modal-md]="size == ModalSize.Md" [class.modal-lg]="size == ModalSize.Lg" [ngClass]="className?className:''"
    [class.modal-xl]="size == ModalSize.Xl" [class.modal-xxl]="size == ModalSize.XXl" (click)="onDialogClicked($event)">
    <div class="kx-cstm-modal-container">
      <div class="modal-header kx-cstm-modal-header p-0">
        <div class="kx-cstm-popup-title">
          <h5>{{title}}</h5>
          @if (closehide!='hide') {
            <span id="visiblePopup" class="kx-modal-close" (click)="onDialogClose($event)"><i class="fa fa-times-circle" aria-hidden="true"></i></span>
          }
        </div>
      </div>
      <!-- <div class="modal-body kx-cstm-popup-body"> -->
      <ng-template appInsertion></ng-template>
    <!-- </div> -->
  </div>
</div>
</div>